import './StageGroup.css'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { Droppable } from 'react-beautiful-dnd'
import SmoothCollapse from 'react-smooth-collapse'
import { memo } from 'react'
import { useCallback } from 'react'

import { Popup } from '../Popup/Popup'
import { ReactComponent as Edition } from '../../icon/edit_line_pen_blue.svg'
import { ReactComponent as Done } from '../../icon/done.svg'
import { ReactComponent as ArrowDown } from '../../icon/arrow-down.svg'
// import { ReactComponent as Bucket } from '../../icon/bucket.svg'
// import Select from '../Select/Select'
import { ReactComponent as RoundRobinIcon } from '../../icon/round_robin.svg'
import { ReactComponent as StrucGreyNew } from '../../icon/struc-grey-new.svg'
import { filterGroupsNodesInLevels } from '../../generalExternalFunctions'
import {
	addParticipant,
	removeParticipant,
	replaceParticipant,
	updateGroupName,
	updateGroupNodes,
	removeGroup,
	removeLevel,
	setStageLevels
} from '../../redux/stageService/stageSlice'
import { GroupPlayer } from '../GroupPlayer/GroupPlayer'

import { addEmptyPlayerInList } from './externalFunctions'

// const selectOptions = [
// 	{
// 		'label': 'Round Robin',
// 		'value': 1
// 	},
// 	{
// 		'label': 'Oplympic+',
// 		'value': 2
// 	}
// ]

const StageGroupComponent = (props) => {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const [popupIsOpened, setPopupIsOpened] = useState(false)
	const [popupList, setPopupList] = useState([])
	const [openedGroupNameEdition, setOpenedGroupNameEdition] = useState(false)
	// const [groupName, setGroupName] = useState('')
	// const [replacedPlayerIndex, setReplacedPlayerIndex] = useState('')
	// const [replaceNameMode, setReplaceNameMode] = useState(false)
	const [hidenGroup, setHidenGroup] = useState(true)
	// const [selectValue, setSelectValue] = useState({})
	const [olympicPlusMatches, setOlympicPlusMatches] = useState([])
	const [playersCountInGroup, setPlayersCountInGroup] = useState([])
	// Добавляем пустого игрока
	useEffect(() => {
		// set participants list according to nodes for group
		const updatedNodesList = addEmptyPlayerInList(props?.nodesList, props?.levels, props?.levelIndex)
		setPopupList(updatedNodesList)
	}, [props?.tournament, props?.nodesList, props?.levels])

	// Смотрим какой тип игры
	useEffect(() => {
		// if (props?.group?.type === "round_robin") {
		// 	setSelectValue(selectOptions[0])
		// } else if (props?.group?.type === "olimpic+") {
		// 	setSelectValue(selectOptions[1])
		// }

		const matches = Array.from({ length: props?.group?.nodes?.length / 2 })
		setOlympicPlusMatches(matches)

		const playersCount = props?.group?.nodes?.filter(n => n?.playerUid || n?.doubleUid)
		setPlayersCountInGroup(playersCount)
	}, [props?.group?.nodes])

	// Получаем event того что пользователь выбрал в select
	// const handleSelectChange = useCallback((event) => {
	// 	setSelectValue(event)
	// }, [])

	const updatePlayerState = useCallback(() => {
		if (Object.keys(props?.chosenPlayerInlist).length !== 0) {
			props?.sendPlayerState({})
		}
	}, [props?.sendPlayerState, props?.chosenPlayerInlist])

	// const openPopup = useCallback(() => {
	// 	updatePlayerState()
	// 	setPopupIsOpened(true)
	// 	document.body.style.overflow = 'hidden'
	// }, [popupList, props?.group?.nodes, updatePlayerState])

	// const closePopup = useCallback(() => {
	// 	setPopupIsOpened(false)
	// 	document.body.style.overflow = 'auto'
	// }, [])

	// const replacePlayer = useCallback((node) => {
	// 	updatePlayerState()

	// 	const levelsWithFilteredGroups = filterGroupsNodesInLevels(props?.levels, node, true)
	// 	const group = {
	// 		...levelsWithFilteredGroups[props?.levelIndex].groups[props?.groupIndex]
	// 	}
	// 	levelsWithFilteredGroups[props?.levelIndex].groups[props?.groupIndex].nodes[replacedPlayerIndex] = {
	// 		...node,
	// 		groupName: group?.name
	// 	}
	// 	dispatch(replaceParticipant(levelsWithFilteredGroups))
	// 	setPopupIsOpened(false)
	// 	props?.updatePlaces(true)
	// }, [updatePlayerState, dispatch, props, filterGroupsNodesInLevels, replacedPlayerIndex])

	// const includeParticipant = useCallback((node) => {
	// 	updatePlayerState()
	// 	// include player in group and update redux statement
	// 	const levelsWithFilteredNodes = filterGroupsNodesInLevels(props?.levels, node)
	// 	dispatch(setStageLevels(levelsWithFilteredNodes))
	// 	dispatch(addParticipant({
	// 		levelIndex: props?.levelIndex,
	// 		groupIndex: props?.groupIndex,
	// 		node
	// 	}))

	// 	const filtredPopupList = popupList?.filter(el => {
	// 		return el?.nodeUid !== node?.nodeUid
	// 	})
	// 	setPopupList(prev => prev = filtredPopupList)
	// 	props?.updatePlaces(true)
	// }, [dispatch, props, popupList, updatePlayerState])

	// const handleNameInPopup = useCallback((node) => {
	// 	if (replaceNameMode) {
	// 		replacePlayer(node)
	// 	} else {
	// 		includeParticipant(node)
	// 	}

	// 	setReplaceNameMode(false)
	// }, [replacePlayer, includeParticipant, replaceNameMode])

	const excludeParticipant = useCallback((node) => {
		if (!props?.auth) {
			return
		}

		updatePlayerState()
		// exclude player from group and update redux statement
		const levelsWithFilteredGroups = filterGroupsNodesInLevels(props?.levels, node)
		dispatch(removeParticipant(levelsWithFilteredGroups))
		props?.updatePlaces(true)
	}, [dispatch, props, updatePlayerState])

	// const handleButtonEdition = useCallback((name) => {
	// 	updatePlayerState()

	// 	if (name) {
	// 		setGroupName(name)
	// 	}

	// 	setOpenedGroupNameEdition(true)
	// }, [updatePlayerState])

	// const handleInputEdition = useCallback((e) => {
	// 	updatePlayerState()
	// 	setGroupName(e.target.value)
	// }, [updatePlayerState, groupName])

	// const handleEditionDone = useCallback(() => {
	// 	updatePlayerState()

	// 	dispatch(updateGroupName({
	// 		levelIndex: props?.levelIndex,
	// 		groupIndex: props?.groupIndex,
	// 		groupName: groupName
	// 	}))

	// 	setOpenedGroupNameEdition(false)
	// 	props?.updatePlaces(true)
	// }, [updatePlayerState, dispatch, props, groupName])

	// const putPlayerInGroup = useCallback((index) => {
	// 	if (!props?.auth) {
	// 		return
	// 	}

	// 	const filtredLevels = filterGroupsNodesInLevels(props?.levels, props?.chosenPlayerInlist?.player, false)

	// 	dispatch(updateGroupNodes({
	// 		levelIndex: props?.levelIndex,
	// 		groupIndex: props?.groupIndex,
	// 		levels: filtredLevels,
	// 		index,
	// 		addedNode: props?.chosenPlayerInlist?.player
	// 	}))

	// 	updatePlayerState()
	// 	props?.updatePlaces(true)
	// }, [dispatch, props, updatePlayerState])

	// const handleName = useCallback((index, node) => {
	// 	if (!props?.auth) {
	// 		return
	// 	}

	// 	if (props?.editingMode && Object.keys(props?.chosenPlayerInlist).length !== 0) {
	// 		putPlayerInGroup(index)
	// 	} else if (!props?.editingMode && Object.keys(props?.chosenPlayerInlist).length !== 0) {
	// 		const levelsWithFilteredGroups = filterGroupsNodesInLevels(
	// 			props?.levels,
	// 			props?.chosenPlayerInlist?.player,
	// 			true
	// 		)
	// 		levelsWithFilteredGroups[props?.levelIndex].groups[props?.groupIndex].nodes[index] = props?.chosenPlayerInlist?.player
	// 		dispatch(replaceParticipant(levelsWithFilteredGroups))
	// 		updatePlayerState()

	// 	} else if (!node?.disabled) {
	// 		setReplacedPlayerIndex(index)
	// 		setReplaceNameMode(true)
	// 		openPopup()
	// 	} else {
	// 		return
	// 	}

	// 	props?.updatePlaces(true)
	// }, [props, putPlayerInGroup, updatePlayerState, openPopup])

	const handleGroupArrow = useCallback(() => {
		setHidenGroup(prev => !prev)
	}, [])

	// const handleRemoveGroup = useCallback(() => {
	// 	updatePlayerState()

	// 	if (props?.levels[props?.levelIndex]?.groups === 1) {
	// 		dispatch(removeLevel(props?.levelIndex))
	// 	} else {
	// 		dispatch(removeGroup({
	// 			levelIndex: props?.levelIndex,
	// 			groupIndex: props?.groupIndex
	// 		}))
	// 	}
	// }, [dispatch, props, updatePlayerState])

	return (
		<>
			<div className="stage-group__header">
				<div className="stage-group__name-container">

					{
						!props?.editingMode &&
							<stage-groupIcon className="stage-group__type-icon" />
					}
					
					{
						props?.group?.type === 'olympic_plus' ?
							<StrucGreyNew style={{width: '25px', height: '25px', marginRight: '10px'}} />
							:
							<RoundRobinIcon style={{width: '25px', height: '25px', marginRight: '10px'}}/>
					}

					<p className="stage-group__name">
						{t('Group')} {!openedGroupNameEdition ? props?.group?.name : ''}
					</p>

					{/* {
						openedGroupNameEdition &&
							<div className="stage-group__name-edition">
								<input
									type="text"
									name="groupName"
									className="stage-group__input-edition"
									value={groupName}
									onChange={e => handleInputEdition(e)}
									maxLength="32"
								/>

								<div onClick={() => handleEditionDone()} className="stage-group__icon-done">
									<Done />
								</div>
							</div>
					} */}

					{/* {
						!props?.editingMode && !openedGroupNameEdition && props?.auth &&
							<div className="stage-group__icon-edition">
								<Edition
									className="edition-icon"
									onClick={() => handleButtonEdition(props?.group?.name)}
								/>
							</div>
					} */}
				</div>

				{/* {props?.editingMode &&
					<div className="stage-group__icon-deletion">
						<Bucket
							onClick={() => handleRemoveGroup()}
							className="bucket__icon"
						/>
					</div>
				} */}
			</div>

			{/* {props?.editingMode &&
				<div className="stage-group__select">
					<Select
						options={selectOptions}
						value={selectValue}
						defaultValue={selectValue}
						onChange={e => handleSelectChange(e)}
					/>
				</div>
			} */}

			<div className="stage-group__players-header" onClick={handleGroupArrow}>
				<p className="stage-group__players-subtitle">
					{t('Players')} ({playersCountInGroup?.length})
				</p>

				<ArrowDown className={hidenGroup ? 'arrow--up' : 'arrow--down'} />
			</div>

			{/* {
				props?.editingMode && hidenGroup &&
					<div>
						<p onClick={openPopup} className="stage-group__participants-addition">
							{t('Add player')}
						</p>
					</div>
			} */}

			{/* {
				popupIsOpened &&
					<Popup
						onClose={closePopup}
						title={t('Participants')}
						close={true}
					>
						{
							popupList?.map((node, index) =>
								<div
									key={index}
									className={
										`stage-group__popup-participants-item ${node?.placed ? 
											'stage-group__popup-participants-item--selected'
											:
											''
										}`
									}
									onClick={() => handleNameInPopup(node)}
								>
									{
										props?.tournament?.type === 'singles' && 
											(node?.playerUid || node?.emptyPlayer) &&
												<>
													<p className="stage-group__popup-participants-name">
														({ node?.rating }) { node?.name }
													</p>

													<p className="stage-group__popup-participants-name">
														{ node?.groupName }
													</p>
												</>
									}

									{
										props?.tournament?.type === 'doubles' &&
											(node?.doubleUid || node?.emptyPlayer) &&
												<div className="stage-group__popup-participants-doubles">
													<p className="stage-group__popup-doubles-rating">
														({node?.rating})
													</p>

													{
														node?.noPlayer ?
															<p>
																{node?.name}
															</p>
															:
															<div>
																<p className="stage-group__popup-participants-name--first">
																	{node?.firstPlayerName}
																</p>
																<p className="stage-group__popup-participants-name--second">
																	{node?.secondPlayerName}
																</p>
															</div>
													}
												</div>
									}
								</div>
							)
						}
					</Popup>
			} */}

			<SmoothCollapse expanded={hidenGroup}>
				<div className="stage-group__components">
					{
						props?.group?.type === 'olympic_plus' &&
							<div>
								{
									olympicPlusMatches?.map((_, nodeIndex) => (
										<div
											key={nodeIndex}
											className="stage-group__number-container"
											style={{height: props?.tournament?.type === 'doubles' ? '130px' : '100px'}}
										>
											<p className="stage-group__number">
												{nodeIndex + 1}
											</p>
										</div>
									))
								}
							</div>
					}

					<Droppable
						key={props?.groupIndex}
						droppableId={`${props?.levelIndex}-${props?.groupIndex}`}
					>
						{
							(provided) => (
								<div
									className="stage-group__players"
									{...provided.droppableProps}
									ref={provided.innerRef}
								>
									{
										props?.group?.nodes?.map((node, index) => (
											<GroupPlayer
												key={node?.nodeUid}
												draggableId={node?.nodeUid}
												index={index}
												// handleName={handleName}
												excludeParticipant={excludeParticipant}
												node={node}
												type={props?.tournament?.type}
												replacingItem={props?.replacingItem}
												droppableId={`${props?.levelIndex}-${props?.groupIndex}`}
												groupType={props?.group?.type}
												isDisabledNode={props?.isDisabledNode}
												nodesCount={props?.group?.nodes?.length}
												dndDisabled={props?.dndDisabled}
											/>
										))
									}

									{
										provided.placeholder
									}
								</div>
							)
						}
					</Droppable>
				</div>
			</SmoothCollapse>
		</>
	)
}

export const StageGroup = memo(StageGroupComponent)